export default function OurStory() {
  return (
    <section className="section py-16 mr-[40px]">
      <div className="ourstory-text text-center max-w-4xl mx-auto">
        <h1 className="ourstory-title text-sky-950">Our Story</h1>
        <p className="ospg text-lg text-gray-600 mb-8">
          The Nisa and Sabir Foundation is named in honor of my beloved mother,
          Sharifun Nisa Begum, who instilled in my family the values of compassion, generosity, and
          the importance of giving back to our communities. Growing up, she
          always reminded me that our greatest wealth lies in what we can share
          with others, especially those who are less fortunate.
        </p>
        <p className="ospg text-lg text-gray-600 mb-8">
          Guided by the principles of Islam instilled in me through her teachings, our foundation
          was established with a mission to create a safe and nurturing environment for underprivileged
          communities from all backgrounds, faiths, and walks of life. We aim to provide them with
          access to essential resources, including educational programs and medical care, ensuring they have
          the opportunities to thrive and succeed in life.
        </p>
      </div>
      <div className="mt-8">
        <a
          href="#learn-more"
          onClick={(e) => {
            e.preventDefault();
            const el = document.getElementById("learn-more");
            if (el) el.scrollIntoView({ behavior: "smooth" });
          }}
          className="text-gray-400 hover:text-gray-500 text-sm tracking-wide underline-offset-4 underline transition-all"
        >
          Learn more about us ↓
        </a>
      </div>
    </section>
  );
}
